export const formatPrice = (price) => {
  if (!price) return 'Price on request';
  if (price >= 10000000) return `₹${(price / 10000000).toFixed(price % 10000000 === 0 ? 0 : 2).replace(/\.?0+$/, '')} Cr`;
  if (price >= 100000) return `₹${(price / 100000).toFixed(price % 100000 === 0 ? 0 : 1).replace(/\.?0+$/, '')} Lac`;
  return `₹${price.toLocaleString('en-IN')}`;
};

export const shortPrice = (price) => {
  if (!price) return '—';
  if (price >= 10000000) return `₹${(price / 10000000).toFixed(price >= 100000000 ? 0 : 1).replace(/\.0$/, '')}Cr`;
  if (price >= 100000) return `₹${Math.round(price / 100000)}L`;
  return `₹${Math.round(price / 1000)}K`;
};

export const pricePerSqft = (property) => {
  if (!property?.price || !property?.area) return null;
  return `₹${Math.round(property.price / property.area).toLocaleString('en-IN')}/${property.area_unit || 'sqft'}`;
};

export const isNewListing = (createdAt, days = 14) => {
  if (!createdAt) return false;
  return Date.now() - new Date(createdAt).getTime() < days * 86400000;
};

export const localityOf = (property) => {
  const first = (property?.address || '').split(',')[0].trim();
  return first && first.length < 40 ? first : property?.city;
};

export const typeLabel = (t) => ({ apartment: 'Apartment', villa: 'Villa', house: 'Independent House', plot: 'Plot / Land', commercial: 'Commercial' }[t] || (t ? t[0].toUpperCase() + t.slice(1) : ''));

// --- Seller contact resolution (no fallback to a support number) ---
export const sellerDial = (property) => {
  const d = (property?.owner_phone_dial || '').replace(/\D/g, '');
  if (d) return d;
  const raw = (property?.owner_phone || '').replace(/\D/g, '');
  if (!raw) return null;
  return raw.length === 10 ? `91${raw}` : raw;
};

export const sellerDisplayPhone = (property) => property?.owner_phone || null;

export const hasSellerCall = (property) => !!sellerDial(property);

export const sellerWhatsApp = (property) => {
  const w = (property?.owner_whatsapp || '').replace(/\D/g, '');
  return w || null;
};

export const canWhatsApp = (property) => !!sellerWhatsApp(property);

export const waLink = (property) => {
  const phone = sellerWhatsApp(property);
  if (!phone) return null;
  const text = `Hi, I found your property on Bharat Estate. I am interested in "${property?.title}", Listing ID ${property?.property_id}. Please share more details.`;
  return `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;
};
